module.exports = __webpack_public_path__ + "static/media/thumb.ba17f262.jpg";